import { TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { textFieldSX } from "../../constants/textFieldCSS";
import { debounce } from 'lodash';

type InputTextBoxProps = {
    setTextValue: (textValue: string) => void;
    initialValue: string | null;
    label?: string;
    additionalClasses?: string;
    size?: "small" | "medium";
    isMultiline?: boolean;
    borderColor?: string;
    borderRadius?: string;
}

const InputTextBox = ({
    setTextValue,
    initialValue,
    label,
    additionalClasses,
    size,
    isMultiline,
    borderColor,
    borderRadius,
}: InputTextBoxProps) => {
    const [value, setValue] = useState(initialValue || '');

    const debouncedSetValue = useMemo(() => debounce(setTextValue, 500), [setTextValue]);

    return (
        <TextField
            multiline={isMultiline}
            fullWidth
            label={label}
            value={value}
            onChange={(e) => {
                setValue(e.target.value);
                debouncedSetValue(e.target.value);
            }}
            sx={{ ...textFieldSX, 
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: borderColor,
                    borderRadius: borderRadius,
                },
             }}
            className={additionalClasses}
            size={size}
        />
    )
}

export default InputTextBox;